import React from 'react';
import { Clock, Activity, MessageCircle, Video } from 'lucide-react';
import './shared-analytics.css';

const ActivityAnalytics = () => {
  return (
    <div className="activity-analytics">
      <div className="analytics-summary">
        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0f9ff', color: '#0891b2' }}>
            <Clock size={24} />
          </div>
          <div className="card-content">
            <h3>Last Interaction</h3>
            <div className="card-value">2h</div>
            <div className="card-change neutral">Patient ID: 47</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#faf5ff', color: '#7c3aed' }}>
            <Activity size={24} />
          </div>
          <div className="card-content">
            <h3>Today's Events</h3>
            <div className="card-value">34</div>
            <div className="card-change positive">+12 from yesterday</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#eff6ff', color: '#3b82f6' }}>
            <MessageCircle size={24} />
          </div>
          <div className="card-content">
            <h3>Messages Sent</h3>
            <div className="card-value">18</div>
            <div className="card-change positive">5 pending replies</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fff7ed', color: '#ea580c' }}>
            <Video size={24} />
          </div>
          <div className="card-content">
            <h3>Videos Watched</h3>
            <div className="card-value">7</div>
            <div className="card-change neutral">62% completion</div>
          </div>
        </div>
      </div>

      <div className="content-placeholder">
        <h3>Patient Activity & Engagement</h3>
        <p>Comprehensive tracking of patient interactions and engagement patterns.</p>
        <ul>
          <li>Real-time activity monitoring</li>
          <li>Patient interaction timeline</li>
          <li>Communication history</li>
          <li>Engagement trend analysis</li>
          <li>Video viewing analytics</li>
        </ul>
      </div>
    </div>
  );
};

export default ActivityAnalytics;



